import { RootState, TypedDispatch } from "../../../../../redux/store";
import { batchInitialStateDTO, createBatchDTO } from "../service/types";
import { connect } from "react-redux";
import BatchListing from "../BatchListing/BatchListing";
import {
  getBatchList,
  getNurtureLeadBoard,
  createBatch,
  getBatchById,
  sendPaymentReminderToBatch,
} from "../service/Batchslice";
import { getBranchList } from "../../ManageBranch/service/Branchslice";
import { getAllCourseByInstituteRequest } from "../../ManageCourse/service/courseSlice";
import { GetCourseConfig } from "../../ManageCourse/service/courseConfigSlice";

interface StateProps extends batchInitialStateDTO {}

interface DispatchProps {
  GetBatchList(data: any): void;
  GetBranchList(id: string): void;
  GetCourseList(id: string): void;
  BatchConfig(): void;
  GetNurtureLeadBoard(id: string): void;
  CreateBatch(data: createBatchDTO): void;
  GetBatchById(id: string): void;
  SendPaymentReminderToBatch(body: any): void;
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    success: state.batch.success,
    error: state.batch.error,
    loading: state.batch.loading,
    batchList: state.batch.batchList,
    batchById: state.batch.batchById,
    batchId: state.batch.batchId,
    batchBookedSession: state.batch.batchBookedSession,
    batchByIdWithCalander: state.batch.batchByIdWithCalander,
    batchListLoading: state.batch.batchListLoading,
    batchCreateSuccess: state.batch.batchCreateSuccess,
    batchCreateError: state.batch.batchCreateError,
    batchCreateLoading: state.batch.batchCreateLoading,
    assigneeSuccess: state.batch.assigneeSuccess,
    assigneeLoading: state.batch.assigneeLoading,
    assigneeError: state.batch.assigneeError,
    assignees: state.batch.assignees,
    batchByIdLoading: state.batch.batchByIdLoading,
    batchUpdateLoading: state.batch.batchUpdateLoading,
    batchUpdateSuccess: state.batch.batchUpdateSuccess,
    batchUpdateError: state.batch.batchUpdateError,
    batchPayUpdateLoading: state.batch.batchPayUpdateLoading,
    batchPayUpdateSuccess: state.batch.batchPayUpdateSuccess,
    batchPayUpdateError: state.batch.batchPayUpdateError,
    demoStudentDeleteLoading: state.batch.demoStudentDeleteLoading,
    demoStudentDeleteSuccess: state.batch.demoStudentDeleteSuccess,
    demoStudentDeleteError: state.batch.demoStudentDeleteError,
    batchSessionLoading: state.batch.batchSessionLoading,
    batchPaymentReminderSuccess: state.batch.batchPaymentReminderSuccess,
    batchPaymentReminderLoading: state.batch.batchPaymentReminderLoading,
    batchPaymentReminderError: state.batch.batchPaymentReminderError,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetBatchList: (data: string) => {
      dispatch(getBatchList(data));
    },
    GetBranchList: (id: string) => {
      dispatch(getBranchList(id));
    },
    GetCourseList: (id: string) => {
      dispatch(getAllCourseByInstituteRequest(id));
    },
    BatchConfig: () => {
      dispatch(GetCourseConfig());
    },
    GetNurtureLeadBoard: (id: string) => {
      dispatch(getNurtureLeadBoard(id));
    },
    CreateBatch: (data: createBatchDTO) => {
      dispatch(createBatch(data));
    },
    GetBatchById: (id: string) => {
      dispatch(getBatchById(id));
    },
    SendPaymentReminderToBatch: (body: any) => {
      dispatch(sendPaymentReminderToBatch(body));
    },
  };
};

export interface BatchListProps extends StateProps, DispatchProps {}

export const BatchListComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(BatchListing);
